import { combineReducers } from 'redux';
import Smartcounts from './Smartcounts';

export default combineReducers({
  Smartcounts,
});
